import * as React from 'react';
import{ Menu, MenuItem, Button } from '@mui/material';
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { Link } from 'react-router';
import styles from './SelectLists.module.scss'
import { styled } from '@mui/system';

// Identical styling to ExportDropDown

const MenuDialog = styled(Menu)(({ theme }) => ({
    '& .MuiPaper-root': {
        marginTop: theme.spacing(4),
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
    },
}));

export default function TopicEditorSelect() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: { currentTarget: any; }) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    }

    return (
        <div style={{marginLeft: '-2.5rem'}}>
            <Button onClick={handleClick} className={styles.Button}>
                Topic Editor <KeyboardArrowDownRounded />
            </Button>
            <MenuDialog
            className={'styled.Menu'}
            elevation={0}
            open={open}
            onClose={handleClose}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }}
            >
                <MenuItem component={Link} to="/editor/create" className={styles.MenuItem}>
                Create Topic
                </MenuItem>

                <MenuItem component={Link} to="/editor/edit" className={styles.MenuItem}>
                Edit Topic
                </MenuItem>
            </MenuDialog>
        </div>
    )
}